// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3GPzK","controls":"styles_controls__3qOn9","charLimit":"styles_charLimit__1SuHT","input":"styles_input__32Wja","send":"styles_send__2fXJv"};